import { Action, Reducer } from "redux";
import {
	ReportScheduleStatusState,
	ReportScheduleStatusTypes,
	ReportScheduleStatusActionTypes,
} from "./reportScheduleStatusTypes";

export const INITIAL_STATE: ReportScheduleStatusState = {
	reportScheduleStatus: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const reportScheduleStatusReducer: Reducer<ReportScheduleStatusState> = (
	state: ReportScheduleStatusState = INITIAL_STATE,
	action: Action,
) => {
	const actionTypes = action as ReportScheduleStatusActionTypes;
	switch (actionTypes.type) {
		case ReportScheduleStatusTypes.GET_REPORT_SCHEDULE_STATUS:
			return {
				...state,
				reportScheduleStatus: { ...state.reportScheduleStatus, isLoading: true },
			};
		case ReportScheduleStatusTypes.SAVE_REPORT_SCHEDULE_STATUS:
			return {
				...state,
				reportScheduleStatus: {
					...state.reportScheduleStatus,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case ReportScheduleStatusTypes.RESET_REDUCER_REPORT_SCHEDULE_STATUS:
			return {
				...state,
				reportScheduleStatus: INITIAL_STATE.reportScheduleStatus,
			};
		default:
			return state;
	}
};

export default reportScheduleStatusReducer;
